// 手机验证
<template>
<div>
<div class="g-hd">
  <h1>安全验证</h1>
</div>
  <component :is="currentView" :options="options" @changeToLogin="change" @changeModule="changeModule"></component>
</div>
</template>

<script>
import reqProxy from '../util/request'
import code from '../util/codemapper'
import util from '../util/util'
// bowser不能升级。4.1.2android
import bowser from "bowser";


export default {
  name: 'verify',
  props: {
    un: String,
    ppdata: Object
  },
  data () {
    return {
      currentView: '',
      options:{un:this.un}
    }
  },
  mounted () {
    this.changeView(this.ppdata);
  },
  methods: {
    // 切换到二次验证方式
    changeView (data) {
      switch(data.yz){
        case '1':
          // 安全手机
          this.currentView = 'verifymb';
          this.options.mb = data.mb
          break;
        case '2':
          // 将军令
          this.currentView = 'verifyopt';
          break;
        case '3':
          // 密保卡
          this.currentView = 'verifyppc';
          this.options.cos = data.cos;
          break;
        case '4':
          // 裸账号
          this.options.receiveCode = data.receiveCode||'';
          this.options.newUp = data.receiveCode?true:false;
          this.currentView = 'verifyluo';
          break;
        default:break;
      }
    },
    change (data) {
      this.$emit('changeToLogin',data);
    },
    smsLink(_code, _number) {
        // bowser不能升级。4.1.2android
        let agent = window.navigator.userAgent,
            joinStr
        if ( bowser.ios ) {
            if ( agent.match(/UcBrowser/i) ) {
                return
            }
            joinStr = `&`
        } else {
            joinStr = `?`
        }
        return 'sms:' + _code + joinStr + "body=" + _number;
    },
    changeModule (data){
      this.currentView = data.module;
      if (this.currentView == 'smsup'){
        this.options.mobile  = data.mobile;
        this.options.fromluo = data.fromluo||false;
        if (!!data.receiveCode){
          let list = data.receiveCode.split(',');
          this.options.receiveCode  = data.receiveCode;
          this.options.receiveCode1 = list[0];
          this.options.receiveCode2 = list[1];
          this.options.receiveCode3 = this.options.receiveCode2.replace(/(.{4})(?=.)/g, "$1 ");
          this.options.smscnt = this.smsLink(this.options.receiveCode2,this.options.receiveCode1);
        }
      }else if (this.currentView == 'verifyluo'){
        this.options.errMsg = data.errMsg||'';
        this.options.receiveCode = data.receiveCode||false;
        this.options.newUp = data.newUp||false;
      }else if (this.currentView == 'verifymb'){
         this.options.errMsg = data.errMsg||'';
      }
    }
  }
}
</script>





// WEBPACK FOOTER //
// Verify.vue?339b1621